module.exports = __webpack_public_path__ + "img/add_white_24px.c3379830.svg";